'use client'

import { ContentLayoutProvider, useContentLayout } from '@/contexts/ContentLayoutContext'
import type { Maybe } from '@/frontend-types'
import type { ContentLayout } from '@/helpers/layout'
import { getLayoutClasses, tagCMSBlock } from '@/helpers/layout'
import { cx } from 'cva'
import type { FC, PropsWithChildren } from 'react'
import { Corridor } from '../atoms/Corridor'
import { Grid } from '../atoms/Grid'

export type ContentBlockWrapperProps = {
	blockTypes?: Maybe<string[]>
	className?: string
	gridClassName?: string
	layout?: ContentLayout
}

export const ContentBlockWrapper: FC<PropsWithChildren<ContentBlockWrapperProps>> = ({
	blockTypes,
	className,
	gridClassName,
	children,
	layout,
}) => {
	const parentLayout = useContentLayout()
	const childLayout = layout || parentLayout
	const blockClasses = tagCMSBlock(blockTypes)

	switch (parentLayout) {
		case 'nested':
			return (
				<div className={cx(getLayoutClasses('nested'), blockClasses, className)}>
					<ContentLayoutProvider layout={childLayout}>{children}</ContentLayoutProvider>
				</div>
			)
		case 'narrow':
			return (
				<section className={cx(getLayoutClasses('narrow'), blockClasses, className)}>
					<Corridor>
						<Grid>
							<div
								className={cx(
									'col-span-full tablet-l:col-span-8 tablet-l:col-start-3',
									'grid grid-cols-4 gap-x-gutter tablet-p:grid-cols-8',
									gridClassName,
								)}
							>
								<ContentLayoutProvider layout={childLayout}>{children}</ContentLayoutProvider>
							</div>
						</Grid>
					</Corridor>
				</section>
			)
		default:
			return (
				<section className={cx(getLayoutClasses('wide'), blockClasses, className)}>
					<Corridor>
						<Grid className={gridClassName}>
							<ContentLayoutProvider layout={childLayout}>{children}</ContentLayoutProvider>
						</Grid>
					</Corridor>
				</section>
			)
	}
}

export default ContentBlockWrapper
